// Session lifetime constants, shared so the API (cookie maxAge + absolute-cap
// check) and the web client (idle-warning modal) agree on durations. Follows
// the existing shared-constants idiom (ATTACHMENT_MAX_BYTES in dto.ts).
export const SESSION_IDLE_TIMEOUT_MS = 1_200_000; // 20 min
export const SESSION_ABSOLUTE_TIMEOUT_MS = 43_200_000; // 12 h
export const SESSION_IDLE_WARNING_MS = 300_000; // warn 5 min before idle logout
//# sourceMappingURL=session.js.map